import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Box,
  Typography,
  InputAdornment,
  IconButton,
  GridProps,
} from '@mui/material';
import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import SparkTextField from './SparkTextField';
import { SPARK_ROUTES } from 'constants/routes';

type SparkPasswordFieldProps = {
  isDisabled?: boolean;
  name: string;
  label?: string;
  placeholder?: string;
  size?: GridProps['xs'];
  renderForgetPasswordLink?: boolean;
  onForgetPasswordClick?: () => void;
  modalView?: boolean;
  showLogo?: boolean;
};

const SparkPasswordField = React.forwardRef(function SparkPasswordField(
  {
    isDisabled,
    name,
    renderForgetPasswordLink = true,
    label,
    placeholder,
    size,
    onForgetPasswordClick,
    modalView,
    showLogo = true,
  }: SparkPasswordFieldProps,
  ref
) {
  const [showPassword, setShowPassword] = React.useState(false);
  const [searchParams] = useSearchParams();
  const scoID = searchParams.get('sco_id');

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleForgotPasswordNavigation = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    if (modalView && onForgetPasswordClick) {
      e.preventDefault();
      onForgetPasswordClick();
      return;
    }
  };
  return (
    <SparkTextField
      name={name}
      inputProps={{ ref: ref }}
      size={size}
      label={
        <Box
          width={'100%'}
          sx={{ display: 'flex', justifyContent: 'space-between' }}
        >
          {label}
          {renderForgetPasswordLink && (
            <Link
              onClick={handleForgotPasswordNavigation}
              to={{
                pathname: SPARK_ROUTES.FORGOT_PASSWORD,
                search: !!scoID ? `sco_id=${scoID}` : '',
              }}
              style={{
                textDecoration: 'none',
                color: '#6267AC',
              }}
            >
              <Typography
                sx={{
                  textDecoration: 'none',
                  fontSize: '14px',
                }}
              >
                Forgot Password
              </Typography>
            </Link>
          )}
        </Box>
      }
      placeholder={placeholder}
      type={showPassword ? 'text' : 'password'}
      disabled={isDisabled}
      endAdornment={
        <InputAdornment position='end'>
          <IconButton
            aria-label='toggle password visibility'
            onClick={handleTogglePasswordVisibility}
            edge='end'
          >
            {!showPassword ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        </InputAdornment>
      }
    />
  );
});

export default SparkPasswordField;
